module.exports = __webpack_public_path__ + "img/pay-folders-sec.f8a821ba.svg";